import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { FORM_INICIO_LLENADO_SILOS } from '../../../config/forms'
import * as actions from '../actions'
import { OperacionesInicioLlenadoSiloDialogView } from '../components/OperacionesInicioLlenadoSiloDialogView.jsx'

class OperacionesInicioLlenadoSiloDialog extends Component {
  render () {
    const { silo, cereal, colorEtiqueta, isNewEtiqueta, setEtiquetaAsNew } = this.props
    return (
      <OperacionesInicioLlenadoSiloDialogView
        silo={silo}
        cereal={cereal}
        colorEtiqueta={colorEtiqueta}
        isNewEtiqueta={isNewEtiqueta}
        setEtiquetaAsNew={setEtiquetaAsNew}
        etiquetaSeleccionada={this.props.etiquetaSeleccionada}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.movimientoSilos.siloOperando,
    colorEtiqueta: state.movimientoSilos.colorEtiqueta,
    cereal: state.cereal.selectedCerealEspecie,
    isNewEtiqueta: state.movimientoSilos.isNewEtiqueta
  }
}

export default reduxForm({
  form: FORM_INICIO_LLENADO_SILOS,
  initialValues: {},
  enableReinitialize: true,
  onChange: actions.onIniciarLlenadoDialogoFormValuesChange
})(connect(mapStateToProps, actions)(OperacionesInicioLlenadoSiloDialog))
